import { createEvent } from "@cobuildlab/react-simple-state";
import { PaypalPayment } from "@devsplan/wealthclub-shared";

export const OnFetchPaypalPayments = createEvent<PaypalPayment[]>();
export const OnFetchPaypalPaymentsError = createEvent();
